import { useEffect } from 'react'

/** How often an open roster or tracking view reads again while the page is visible: positions arrive all race long. */
export const REFRESH_EVERY_MS = 60_000

/** Runs `load` now, and again every REFRESH_EVERY_MS while the page is visible. */
export function useRefresh(load: () => Promise<void>) {
  useEffect(() => {
    void load()
    const timer = window.setInterval(() => {
      if (document.visibilityState !== 'hidden') void load()
    }, REFRESH_EVERY_MS)
    return () => window.clearInterval(timer)
  }, [load])
}
